// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer___X_ABR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/LAFooter/LAFooter.scss
// module id = qPVN
// module chunks = 57